module.exports = __webpack_public_path__ + "18b4ddcb9592937a7e235d3a415c55a2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-20.png
// module id = 2255
// module chunks = 0